module.exports = __webpack_public_path__ + "static/media/thanks.92fdf873.mp3";